import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../actions";

export function getNavDividendContent({},navType='nav') {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getNavDividend(navType))
            .then((json) => {
                dispatch(hideMainLoader());
                navType== 'nav' && json && dispatch({ type: ACTION.GET_NAV_CONTENT , data: json.data });
                navType== 'dividend' && json && dispatch({ type: ACTION.GET_DIVIDEND_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with nav & dividend detail page content " + error)
            });
    }
}

export function getNavDividendFundFilter() {
    return dispatch => {
        return request(requestConfig.getNavDividendFundFilter())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_NAV_FUND_FILTER , data: json.data });
            }).catch((error) => {
                console.log("Got Error with nav & dividend Fund filter " + error);
            });
    }
}

export function getHistoricData(formData,navType) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getHistoricData(formData))
            .then((json) => {
                dispatch(hideMainLoader());
                navType== 'nav' && json && dispatch({ type: ACTION.GET_HISTORIC_DATA_NAV , data: json.data });
                navType== 'dividend' && json && dispatch({ type: ACTION.GET_HISTORIC_DATA_DIVIDEND , data: json.data });
                return json.data;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with hiistoric data filter " + error);
            });
    }
}


export function gethistoricalDataLoading() {
    return {type: ACTION.GET_HISTORIC_DATA_LOADING};

}

export function postNavDividendSearch(navType,formData,query) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.postNavDividendSearch(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                navType== 'nav' && json && dispatch({ type: ACTION.GET_NAV_SEARCH_CONTENT, data: json.data, query: query });
                navType== 'dividend' && json && dispatch({ type: ACTION.GET_DIVIDEND_SEARCH_CONTENT, data: json.data, query: query });
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with nav dividend search data: " + error)
            });
    }
}

